

















































































import Vue from 'vue'
import { cookie } from '../http/utils'
import bus from '../bus'

export default Vue.extend({
  data () {
    return {
      isShowTip: false,
      menuList: [
        {
          name: 'aboutus',
          text: '关于我们',
          path: '/about-us',
          children: [
            { name: 'talkmateIntro', text: '全球说简介', path: '/about-us/talkmate-intro' },
            // { name: 'utnIntro', text: 'UTN简介', path: '/about-us/utn-intro' },
            // { name: 'professonalCommittee', text: '专家顾问', path: '/about-us/professonal-committee' },
            { name: 'joinUs', text: '加入我们', path: '/about-us/join-us' }
          ]
        },
        {
          name: 'productService',
          text: '产品与服务',
          path: '/public-service',
          children: [
            { name: 'talkmate', text: '全球说APP', path: '/product-service/talkmate' },
            // { name: 'childrenCourse', text: '儿童多语言启蒙', path: '/product-service/children-course' },
            { name: 'translation', text: '翻译服务', path: '/product-service/translation' },
            // { name: 'proCourse', text: '多语课程PRO', path: '/product-service/pro-course' },
            // { name: 'childrenClass', text: '儿童多语实验班', path: '/product-service/children-class' },
            // { name: 'partner', text: '合作伙伴', path: '/product-service/partner' }
            { name: 'WebResource', text: '服务平台', path: '/product-service/web-resource' }
          ]
        },
        {
          name: 'learningCommonweal',
          text: '学术与公益',
          path: '/learning-commonweal',
          children: [
            // { name: 'researchProject', text: '课题研究', path: '/learning-commonweal/research-project' },
            { name: 'langProtection', text: '语言保护与推广', path: '/learning-commonweal/lang-protection' },
            { name: 'langCompetition', text: 'Language Champion', path: '/learning-commonweal/lang-competition' }
          ]
        }
      ],
      addressList: [
        '京ICP备14044248号',
        '公安部备案号 11010502036358',
        '出版物经营许可证 第朝180182号',
        '办学许可证 教民111010873930321号',
        '增值电信业务经营许可证 京ICP证160847号',
        '广播电视节目制作经营许可证 (京)字第22702号'
      ],
      activeLang: {},
      langList: [
        { code: 'zh-CN', class: 'chi', text: '中文', flag: require('../assets/images/common/icon-chi.svg') },
        { code: 'en', class: 'eng', text: 'English', flag: require('../assets/images/common/icon-eng.svg') }
        // { code: 'FRE', class: 'FRE', text: 'French', flag: require('../assets/images/common/icon-fre.svg') }
      ]
    }
  },
  mounted () {
    let cookieCode = cookie.getCookie('LANG_MODE', this.$i18n.locale)
    let newCode = this.langList.filter((item) => {
      return item.code === cookieCode
    })
    console.log('newCode', newCode)
    this.activeLang = newCode[0]
    // if (this.$i18n.locale === 'en') {
    //   this.langList.reverse()
    // }
    // $('.footer .tabLang').hover(() => {
    //   $('.langList').finish().animate({ top: '-=30' }, 200)
    // }, () => {
    //   if (cookie.getCookie('LANG_MODE') === this.langList[0].code) {
    //     $('.langList').finish().animate({ top: '+=30' }, 200)
    //   } else {
    //     $('.langList').css('top', 0)
    //     this.langList.reverse()
    //   }
    // })
  },
  methods: {
    changLang (lang:any) {
      console.log('lang', lang)
      if (lang.code === 'FRE') {
        return
      }
      this.activeLang = lang
      cookie.setCookie('LANG_MODE', lang.code)
      cookie.autoCookie('lang', lang.code)
      this.$i18n.locale = lang.code
      window.scrollTo(0, 0)
    },
    goToPath (goPath:any) {
      this.$router.push({ path: goPath })
      window.scrollTo(0, 0)
      bus.$emit('initNewDate')
    },
    // 移入
    mouseenterFn () {
      this.isShowTip = true
    },
    // 移出
    mouseleaveFn () {
      this.isShowTip = false
    }
  }
})
